import React, { FC } from "react";
import classNames from "classnames";

import { Button } from "./Button";
import { StreamLineIcon } from "../../SvgIcon/StreamLineIcon";

interface KeywordProps {
  onClick: () => void;
  isSelected: boolean;
  label: string;
}

export const Keyword: FC<KeywordProps> = (props) => {
  const { isSelected, label, onClick } = props;

  return (
    <Button
      className="keyword"
      onClick={onClick}
      type="underline"
      tier={isSelected ? "primary" : "secondary"}
      size="small"
    >
      <span
        className={classNames("keyword__label", {
          "keyword__label--selected": isSelected,
        })}
      >
        {label}
      </span>
      {isSelected && (
        <StreamLineIcon className="keyword__icon" iconName="s-close-small" />
      )}
    </Button>
  );
};
